import { TimingTriggerType, TRIGGER_TYPE_TIMING } from "features/Trigger/TemplateTrigger/models";

export const DEFAULT_TIME_OF_DAY = "09:00:00";

type TRIGGER_DEFAULT_VALUES_TYPE = {
  trigger: {
    type: TimingTriggerType;
    data: {
      referenceEvent: "start_date";
      offsetDirection: "exact";
      timeOfDay: string;
      timezoneType: "target_timezone";
    };
  };
};

export const TRIGGER_DEFAULT_VALUES: TRIGGER_DEFAULT_VALUES_TYPE = {
  trigger: {
    type: TRIGGER_TYPE_TIMING,
    data: {
      referenceEvent: "start_date",
      offsetDirection: "exact",
      timeOfDay: DEFAULT_TIME_OF_DAY,
      timezoneType: "target_timezone",
    },
  },
};
